const { createReducer } = require('./factory');

const READ_COMIC_SUCCESSFUL = 'READ_COMIC_SUCCESSFUL';

module.exports = createReducer('READ_COMICS', {
  fetchTimeout: 30 * 1000,
  invalidateActions: ['LOGIN_SUCCESSFUL'],
  minUpdate: 30 * 60 * 1000,
  extendedReducer: {
    [READ_COMIC_SUCCESSFUL]: (state, action) => ({
      ...state,
      items: { ...state.items, [action.comicId]: true },
    }),
    LOGOUT_SUCCESSFUL: (state) => ({
      ...state,
      items: {},
    }),
  },
});

module.exports.readComic = (comicId) => ({
  type: READ_COMIC_SUCCESSFUL,
  comicId,
});
